import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { api } from '@/lib/api';

export function DeleteAccountButton({
  accountId,
  personaId,
}: {
  accountId: string;
  personaId: string;
}) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const m = useMutation({
    mutationFn: () => api.deleteAccount(accountId),
    onSuccess: () => {
      toast.success('Account deleted');
      setOpen(false);
      void queryClient.invalidateQueries({ queryKey: ['persona', personaId, 'accounts'] });
    },
    onError: (err) => toast.error('Delete failed', { description: String(err) }),
  });

  return (
    <>
      <Button
        size="icon"
        variant="ghost"
        onClick={() => setOpen(true)}
        disabled={m.isPending}
        aria-label="Delete account"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
      {open && (
        <ConfirmDialog
          title="Delete this account?"
          description="The account and its stored session are permanently removed from Ghost. This can't be undone — you'd have to connect it again from scratch."
          confirmLabel="Delete"
          destructive
          pending={m.isPending}
          onConfirm={() => m.mutate()}
          onCancel={() => setOpen(false)}
        />
      )}
    </>
  );
}
